var module = angular.module('octopusApp.library');

module.controller('LifecycleEditController', function($scope, $stateParams, $state, busy, pageTitle, octopusRepository, $uibModal, octoDialog, unsavedChanges) {
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();

  var lifecycleId = $stateParams["id"];

  $scope.lifecycle = null;
  $scope.environmentsById = {};

  var repository = octopusRepository.Lifecycles;

  $scope.removeEnvironment = function(phaseCollection, target) {
    phaseCollection.splice(phaseCollection.indexOf(target), 1);
    unsavedChanges.unsaved();
  };

  isLoading.promise(octopusRepository.Environments.all().then(function (envs) {
    $scope.environments = envs;
    $scope.environmentsById = _.object(_.pluck($scope.environments, "Id"), $scope.environments);

    if (lifecycleId) {
      isLoading.promise(repository.get(lifecycleId).then(function (lifecycle) {
        isLoading.promise(octopusRepository.Lifecycles.projects(lifecycle).then(function (projects) {
          $scope.lifecycle = lifecycle;
          $scope.projects = projects;
          pageTitle(lifecycle.Name);
        }));
      }));
    } else {
      $scope.lifecycle = {
        Name: "",
        Phases: [],
          ReleaseRetentionPolicy: {
              "ShouldKeepForever": true,
              "QuantityToKeep": 0,
              "Unit": "Items"
          },
          TentacleRetentionPolicy: {
              "ShouldKeepForever": true,
              "QuantityToKeep": 0,
              "Unit": "Items"
          }
      };
      pageTitle('Create lifecycle');
    }
  }));

  $scope.envCount = function(phase) {
    var count = _.union(phase.OptionalDeploymentTargets, phase.AutomaticDeploymentTargets).length;
    if (phase.MinimumEnvironmentsBeforePromotion > count) {
      phase.MinimumEnvironmentsBeforePromotion = count;
    }
    return count;
  };

  $scope.removePhase = function(phase) {
    unsavedChanges.unsaved();
    var ix = $scope.lifecycle.Phases.indexOf(phase);
    if (ix >= 0) {
      $scope.lifecycle.Phases.splice(ix, 1);
    }
  };

  $scope.addPhase = function () {
    unsavedChanges.unsaved();
    $scope.lifecycle.Phases.push({
      Name: "",
      MinimumEnvironmentsBeforePromotion: 0,
      AutomaticDeploymentTargets: [],
      OptionalDeploymentTargets: []
    });
  };

  $scope.save = function() {
    isSaving.promise(repository.save($scope.lifecycle).then(function(saved){
      unsavedChanges.saved();
      $state.go("app.library.lifecycles");
    }));
  };

  $scope.reorder = function() {
    octoDialog.sort({
      title: "Reorder Phases",
      saveButtonText: "Save",
      load: function(dialog) {
        var id = -1;
        dialog.render(_.map($scope.lifecycle.Phases, function (p) {
          id++;
          return {
            id: id,
            name: p.Name
          };
        }));
      },
      save: function (items, dialog) {
        var newPhases = [];
        _.each(items, function (ix) {
          newPhases.push($scope.lifecycle.Phases[ix]);
        });
        $scope.lifecycle.Phases = newPhases;
        unsavedChanges.unsaved();
        dialog.dismiss();
      }
    });
  };

  $scope.getParentPolicy = function(phase, index) {
    for (var i = index; i >= 0; i--) {
      var parentPhase = $scope.lifecycle.Phases[i];
      if (parentPhase.ReleaseRetentionPolicy) {
        return parentPhase;
      }
    }

    return $scope.lifecycle;
  };

  $scope.resetRetentionPolicy = function (phase) {
    phase.ReleaseRetentionPolicy = null;
    phase.TentacleRetentionPolicy = null;
  };

  $scope.changeRetentionPolicy = function (phaseOrLifecycle) {
    var policy = {
      ReleaseRetentionPolicy: {
        "ShouldKeepForever": true,
        "QuantityToKeep": 0,
        "Unit": "Items"
      },
      TentacleRetentionPolicy: {
        "ShouldKeepForever": true,
        "QuantityToKeep": 0,
        "Unit": "Items"
      }
    };

    if (phaseOrLifecycle.ReleaseRetentionPolicy) {
      policy.ReleaseRetentionPolicy = angular.copy(phaseOrLifecycle.ReleaseRetentionPolicy);
      policy.TentacleRetentionPolicy = angular.copy(phaseOrLifecycle.TentacleRetentionPolicy);
    }

    $uibModal.open({
      backdrop: true,
      keyboard: true,
      templateUrl: 'areas/library/lifecycles/views/policy_edit_dialog.html',
      controller: 'LifecyclePolicyEditDialogController',
      resolve: {
        policy: function () { return policy; }
      }
    }).result.then(function(result) {
      if (result) {
        unsavedChanges.unsaved();
        phaseOrLifecycle.ReleaseRetentionPolicy = result.ReleaseRetentionPolicy;
        phaseOrLifecycle.TentacleRetentionPolicy = result.TentacleRetentionPolicy;
      }
    });
  };

  $scope.addEnvironment = function(phase) {
    var environmentsInUse = {};
    _.each($scope.lifecycle.Phases, function (p) {
      _.each(p.AutomaticDeploymentTargets, function (e) { environmentsInUse[e] = true; });
      _.each(p.OptionalDeploymentTargets, function (e) { environmentsInUse[e] = true; });
    });

    var candidateEnvironments = [];
    _.each($scope.environments, function (e) {
      if (!environmentsInUse[e.Id]) {
        candidateEnvironments.push(e);
      }
    });

    $uibModal.open({
      backdrop: true,
      keyboard: true,
      templateUrl: 'areas/library/lifecycles/views/add_environment_dialog.html',
      controller: 'LifecycleAddEnvironmentDialogController',
      resolve: {
        environments: function () { return candidateEnvironments; }
      }
    }).result.then(function(result) {
      if (result) {
        unsavedChanges.unsaved();
        if (result.trigger === 'Automatic') {
          phase.AutomaticDeploymentTargets.push(result.environmentId);
        } else {
          phase.OptionalDeploymentTargets.push(result.environmentId);
        }
      }
    });
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/lifecycles/controllers/lifecycle_edit_controller.js
// module id = 449
// module chunks = 1